import React from 'react';

import SingleChartH2H from './SingleChartH2H';
import DisclaimerH2H from '../h2h-disclaimer/DisclaimerH2H';

import scss from './ChartsH2H.module.scss';

function ChartsH2H({ selectedH2HConcepts, isGlobalPercentage }) {
  if (!selectedH2HConcepts.length) {
    return <DisclaimerH2H />;
  }

  return (
    <div className={scss.wrapper}>
      {selectedH2HConcepts.map((h2hConcept) => (
        <SingleChartH2H key={h2hConcept.value} h2hConcept={h2hConcept} isGlobalPercentage={isGlobalPercentage} />
      ))}
    </div>
  );
}

export default ChartsH2H;
